import type { CandleWithFlag } from "features/chart";

export interface AlligatorLines {
  jaws: (number | null)[];
  teeth: (number | null)[];
  lips: (number | null)[];
}

function smma(prices: number[], period: number): (number | null)[] {
  const result: (number | null)[] = new Array(prices.length).fill(null);
  if (prices.length < period) return result;
  let sum = 0;
  for (let i = 0; i < period; i++) sum += prices[i];
  result[period - 1] = sum / period;
  for (let i = period; i < prices.length; i++) {
    result[i] = (result[i - 1]! * (period - 1) + prices[i]) / period;
  }
  return result;
}

function shiftForward(arr: (number | null)[], shift: number): (number | null)[] {
  const out: (number | null)[] = new Array(arr.length + shift).fill(null);
  for (let i = 0; i < arr.length; i++) {
    if (arr[i] !== null) out[i + shift] = arr[i];
  }
  return out;
}

export function calcAlligator(
  data: CandleWithFlag[],
  jawsPeriod: number, jawsShift: number,
  teethPeriod: number, teethShift: number,
  lipsPeriod: number, lipsShift: number,
): AlligatorLines {
  const medians = data.map(c => (c.high + c.low) / 2);
  return {
    jaws: shiftForward(smma(medians, jawsPeriod), jawsShift),
    teeth: shiftForward(smma(medians, teethPeriod), teethShift),
    lips: shiftForward(smma(medians, lipsPeriod), lipsShift),
  };
}
